export function getTopOf(selector: string, offset = 0): number {
  if (typeof window === 'undefined') return 0
  const el = document.querySelector(selector) as HTMLElement | null
  if (!el) return 0
  return el.getBoundingClientRect().top + window.scrollY - offset
}

export function scrollToY(top: number, behavior: ScrollBehavior = 'auto') {
  if (typeof window === 'undefined') return
  window.scrollTo({ top, behavior })
}
